import { render, staticRenderFns } from "./ServiceChargeCreate.vue?vue&type=template&id=0e866e7c&scoped=true&"
import script from "./ServiceChargeCreate.vue?vue&type=script&lang=js&"
export * from "./ServiceChargeCreate.vue?vue&type=script&lang=js&"
import style0 from "./ServiceChargeCreate.vue?vue&type=style&index=0&id=0e866e7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e866e7c",
  null
  
)

export default component.exports